import { render, staticRenderFns } from "./ListOfAttachments.vue?vue&type=template&id=5080914c&"
import script from "./ListOfAttachments.vue?vue&type=script&lang=js&"
export * from "./ListOfAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports